
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class CamlyticsGrid extends Serenity.EntityGrid<CamlyticsRow, any> {
        protected getColumnsKey() { return 'Master.Camlytics'; }
        protected getDialogType() { return CamlyticsDialog; }
        protected getIdProperty() { return CamlyticsRow.idProperty; }
        protected getInsertPermission() { return CamlyticsRow.insertPermission; }
        protected getLocalTextPrefix() { return CamlyticsRow.localTextPrefix; }
        protected getService() { return CamlyticsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}